(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("ngx-subscribe", [], factory);
	else if(typeof exports === 'object')
		exports["ngx-subscribe"] = factory();
	else
		root["ngx-subscribe"] = factory();
})(this, function() {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition